import { Component, Input} from '@angular/core';
import { GrowlerData, GrowlerService } from "@netfoundry-ui/shared/growler";

@Component({
    selector: 'lib-scim-integration-url-copy',
    templateUrl: './scim-integration-url-copy.component.html',
    styleUrls: ['./scim-integration-url-copy.component.scss'],
    standalone: false
})
export class ScimIntegrationUrlCopyComponent {
  
  @Input() baseUrl: string;
  @Input() integrationKey: string;
  pathEnd = "/scim/v2";

  constructor(
    private growlerService: GrowlerService
  ) {
  }

 copyIntegrationUrl() {
    navigator.clipboard.writeText(`${this.baseUrl}${this.integrationKey}${this.pathEnd}`);
    this.growlerService.show(
        new GrowlerData(
            'success',
            'Success',
            'Integration URL Copied',
            'The URL has been copied to your clipboard'
        )
    );
  }

}

